import React, { useState } from 'react';
import { ISubmitScoreSidebarPanel } from './interfaces';
import { ContentPanel } from '../../../../../../components/ContentPanel';
import { Button, Typography } from '@mui/material';
import { SidebarPanelTitle } from '../../../../../../components/content-side-bar/SidebarPanelTitle';
import { SubmitScoreDialog } from '@pages/Portal/Competitions/dialogs/SubmitScoreDialog';
import { useTranslation } from 'react-i18next';

export const SubmitScoreSidebarPanel: React.FC<ISubmitScoreSidebarPanel> = ({
  slug,
  startsOn,
  endsOn,
  weaponGroups,
  onSubmit,
}): JSX.Element => {
  const { t } = useTranslation();
  const [showSubmitDialog, setShowSubmitDialog] = useState<boolean>(false);

  return (
    <ContentPanel borderRadius="none">
      <SidebarPanelTitle
        title={t('competitions:portal.dialogs.submitScore.sidebar.title')}
      />
      <Typography variant="body2">
        {t('competitions:portal.dialogs.submitScore.sidebar.description')}
      </Typography>
      <Button
        variant="contained"
        fullWidth
        onClick={() => setShowSubmitDialog(true)}
        sx={{
          mt: '10px',
        }}
      >
        {t('competitions:portal.dialogs.submitScore.sidebar.button')}
      </Button>
      <SubmitScoreDialog
        slug={slug}
        startsOn={startsOn}
        endsOn={endsOn}
        weaponGroups={weaponGroups}
        show={showSubmitDialog}
        onClose={() => setShowSubmitDialog(false)}
        onSubmit={onSubmit}
      />
    </ContentPanel>
  );
};
